<template>
    <span :title="JSON.stringify(value)">{{recordCount}}</span>
</template>

<script>
export default {
    name : 'ViewTicketCount',

    props : ['value'],

    data() {
        return {
            recordCount : '..'
        }
    },

    watch: {
        value() {
            this.countByFilterCached();
        }
    },

    methods : {
        countByFilterCached() {
            var _this = this;

            if ( !window.ViewTicketCountList ) {
                window.ViewTicketCountList = [];
            }

            window.ViewTicketCountList.push(this);

            clearTimeout(window.ViewTicketCountTimeoutId);
            window.ViewTicketCountTimeoutId = setTimeout(this._doLoad, 200);
        },

        _doLoad() {
            var _this = this;

            if ( !window.ViewTicketCountList ) {
                console.log("#41 window.ViewTicketCountList=", window.ViewTicketCountList);

                clearTimeout(window.ViewTicketCountTimeoutId);
                window.ViewTicketCountTimeoutId = setTimeout(this._doLoad, 1500); // 太快了？
                return;
            }

            sdk.TicketApi().listCountByFilterCached({
                filters : window.ViewTicketCountList.map(e => e.value.filter)
            }).then(res=> {
                for ( var i=0; i < window.ViewTicketCountList.length; i++ ) {
                    var _each = window.ViewTicketCountList[i];
                    _each.recordCount = res[i];
                }

                // 清理
                window.ViewTicketCountTimeoutId = null;
                window.ViewTicketCountList = null;
            });
        }
    },

    mounted() {
        this.countByFilterCached();
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/ViewTicketCount.vue